import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "./alert";
import t from "@/lang/lang";

export function Alert403() {
  return (
    <Alert variant="destructive">
      <AlertTriangle />
      <AlertTitle>403</AlertTitle>
      <AlertDescription>{t("Nicht erlaubt")}</AlertDescription>
    </Alert>
  );
}
